import { useSilhouetteStore } from '../dal/silhouette-store';
import { getSilhouetteData } from '../domain/silhouette-provider';
import { getPointString } from '../../cluster-provider';

const SilhouetteView = () => {

    const params = useSilhouetteStore(store => store.params);
    const distance = useSilhouetteStore(store => store.distance);

    const data = getSilhouetteData(params, distance);

    return (
        <div className="flex gap-4 items-start">
            {
                data &&
                <div>
                    {
                        data.results.map((result, i) => {
                            return (
                                <div key={ i } className={ result.silhouette < 0 ? 'text-sky-700' : '' }>
                                    <strong>Point:</strong> { getPointString(result.point) }, <strong>Silhouette:</strong> {result.silhouette}
                                </div>
                            )
                        })
                    }


                    <hr className="my-8" />

                    {
                        data.calculations.map((calculation, i) => {
                            return (
                                <div key={ `calc-${ i }` }>
                                    { calculation }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
};

export default SilhouetteView;